import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp, FaFacebook, FaTwitter, FaInstagram, FaChevronDown } from 'react-icons/fa';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import bgImage from '../../assets/img/pictures/tttt.jpg';

const Contact = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [openFaq, setOpenFaq] = useState(null);

  const contactInfo = {
    general: {
      phone: "+233 543370183",
      email: "info@kempshotsportsacademy.com",
      whatsapp: "+233 543370183"
    },
    admissions: {
      phone: "+233 543370183",
      email: "info@kempshotsportsacademy.com",
      hours: "Mon-Fri: 9:00 - 17:00"
    },
    facilities: {
      phone: "+233 543370183",
      email: "info@kempshotsportsacademy.com",
      hours: "Mon-Sun: 8:00 - 18:00"
    }
  };

  const faqs = [
    {
      question: "What are the admission requirements?",
      answer: "We evaluate players based on their technical skills, physical attributes, and potential. Trials are conducted monthly for different age groups."
    },
    {
      question: "Do you offer scholarships?",
      answer: "Yes, we offer merit-based scholarships to exceptional talents. The scholarship covers training fees and educational support."
    },
    {
      question: "What is the training schedule like?",
      answer: "Training sessions are conducted 3-5 times per week, depending on the age group and program. Sessions typically last 90-120 minutes."
    },
    {
      question: "Do you provide accommodation?",
      answer: "Yes, we offer supervised accommodation facilities for players from outside Accra, with full boarding and meal services."
    }
  ];

  return (
    <div className="min-h-screen relative">
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <img
          src={bgImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95"></div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Contact KSA</h1>
                <p className="text-xl text-blue-100 mb-8">
                  Have questions about Kempshot Sports Academy? We're here to help you on your journey to excellence.
                </p>
                <div className="flex flex-wrap gap-4">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    Schedule a Visit
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white/10 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/20 transition-colors duration-200"
                  >
                    View FAQs
                  </motion.button>
                </div>
              </motion.div>
              
              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                  <motion.img
                    src={require("../../assets/img/pictures/WhatsApp Image 2025-02-27 at 21.45.52_fdc9a380.jpg")}
                    alt="Contact KSA"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                  />
                  <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                      <p className="text-sm font-semibold">Available 24/7</p>
                    </div>
                    <p className="text-xs opacity-80 mt-1">Quick Response Guaranteed</p>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Contact Methods */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {/* Phone Contact */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/15 transition-all duration-300"
              >
                <div className="text-4xl text-blue-400 mb-6 flex justify-center">
                  <FaPhone />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-3">Call Us</h3>
                <p className="text-blue-100 mb-4">Mon - Fri, 8am - 6pm</p>
                <a 
                  href="tel:+233543370183" 
                  className="text-blue-400 hover:text-blue-300 text-lg font-medium block"
                >
                  +233 543 370 183
                </a>
              </motion.div>

              {/* Email Contact */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/15 transition-all duration-300"
              >
                <div className="text-4xl text-blue-400 mb-6 flex justify-center">
                  <FaEnvelope />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-3">Email Us</h3>
                <p className="text-blue-100 mb-4">We'll respond within 24 hours</p>
                <a 
                  href="mailto:kemps@kempshot.com" 
                  className="text-blue-400 hover:text-blue-300 text-lg font-medium block break-words"
                >
                  kemps@kempshot.com
                </a>
              </motion.div>

              {/* WhatsApp Contact */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/15 transition-all duration-300"
              >
                <div className="text-4xl text-blue-400 mb-6 flex justify-center">
                  <FaWhatsapp />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-3">WhatsApp</h3>
                <p className="text-blue-100 mb-4">Quick Responses</p>
                <a 
                  href="https://wa.me/233543370183" 
                  className="text-blue-400 hover:text-blue-300 text-lg font-medium block"
                >
                  +233 543 370 183
                </a>
              </motion.div>
            </div>

            {/* Contact Form */}
            {/* <div className="max-w-4xl mx-auto">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8"
              >
                <h2 className="text-2xl font-bold text-white mb-6">Send us a Message</h2>
                <p className="text-blue-100 mb-6">Get in touch with KSA - we're here to assist you.</p>
                <form className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-blue-100 mb-2 text-sm">Name</label>
                      <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                        placeholder="Your name"
                      />
                    </div>
                    <div>
                      <label className="block text-blue-100 mb-2 text-sm">Email</label>
                      <input
                        type="email"
                        className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                        placeholder="Your email"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-blue-100 mb-2 text-sm">Subject</label>
                    <select className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400">
                      <option value="general">General Inquiry</option>
                      <option value="admission">Admission</option>
                      <option value="facilities">Facilities</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-blue-100 mb-2 text-sm">Message</label>
                    <textarea
                      rows="4"
                      className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                      placeholder="Your message"
                    ></textarea>
                  </div>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-full bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    Send Message
                  </motion.button>
                </form>
              </motion.div>
            </div> */}
          </div>
        </section>

        {/* Location Section */}
        <section className="py-12 bg-white/5">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="space-y-6"
              >
                <h2 className="text-3xl font-bold text-white mb-8">Visit KSA</h2>
                <div className="space-y-6 text-blue-100">
                  <div className="flex items-start gap-4 bg-white/10 p-6 rounded-xl">
                    <FaMapMarkerAlt className="text-blue-400 text-2xl flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-white font-semibold mb-2">Kempshot Sports Academy (KSA)</h3>
                      <p className="text-lg leading-relaxed">
                        Kempshot School Fiifi Pratt Junction,<br />
                        Kasoa Nyanyano Road,<br />
                        Central Region, Ghana
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4 bg-white/10 p-6 rounded-xl">
                    <FaClock className="text-blue-400 text-2xl flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-white font-semibold mb-2">Opening Hours</h3>
                      <p className="space-y-1">
                        <span className="block">Monday - Friday: 8:00 AM - 6:00 PM</span>
                        <span className="block">Saturday: 9:00 AM - 4:00 PM</span>
                        <span className="block">Sunday: Closed (Except for Matches)</span>
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Map remains the same */}
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="rounded-xl overflow-hidden shadow-2xl"
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3970.5233559666073!2d-0.4162017!3d5.4865332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMjknMTEuNSJOIDDCsDI0JzU4LjMiVw!5e0!3m2!1sen!2sgh!4v1635927234054!5m2!1sen!2sgh"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  className="rounded-xl"
                ></iframe>
              </motion.div>
            </div>
          </div>
        </section>

        {/* FAQs Section */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-4">Frequently Asked Questions</h2>
              <p className="text-xl text-blue-100">Find quick answers about KSA</p>
            </motion.div>

            <div className="max-w-3xl mx-auto">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="mb-4"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full text-left bg-white/10 backdrop-blur-sm p-6 rounded-xl flex items-center justify-between"
                  >
                    <span className="text-lg font-semibold text-white">{faq.question}</span>
                    <FaChevronDown
                      className={`text-blue-400 transition-transform duration-200 ${
                        openFaq === index ? 'transform rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.2 }}
                      className="bg-white/5 backdrop-blur-sm p-6 rounded-b-xl mt-1"
                    >
                      <p className="text-blue-100">{faq.answer}</p>
                    </motion.div>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Social Media Section */}
        <section className="py-12">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-white mb-8">Connect With Us</h2>
            <div className="flex justify-center gap-6">
              {[
                { icon: <FaFacebook />, link: "https://web.facebook.com/profile.php?id=61559738480857", label: "Facebook" },
                // { icon: <FaTwitter />, link: "#", label: "Twitter" },
                // { icon: <FaInstagram />, link: "#", label: "Instagram" }
              ].map((social, index) => (
                <motion.a
                  key={social.label}
                  href={social.link}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="text-3xl text-blue-400 hover:text-blue-300 transition-colors duration-200"
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Contact; 